import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import {useIntl} from 'react-intl';

import {labelFor} from './factLabels';

/**
 * Texto del botón: el placeholder sin selección y "N selec." con una o más.
 * Los niveles elegidos solo se ven al abrir el menú.
 */
export function bandToggleLabel(intl, placeholder, count) {
    return count > 0
        ? intl.formatMessage(
              {id: 'RELEVANCE.PROMOTED_FILTER_BAND_SELECTED'},
              {count},
          )
        : placeholder;
}

/**
 * Botón con el mismo aspecto que los `select` de la barra (`custom-select`:
 * borde gris, fondo blanco, texto del body y flecha propia). Con
 * `Dropdown.Toggle` + `variant` heredaba `$secondary` (#BF76FF) en texto y
 * hover. `custom-select` ya pinta la flecha, así que se quita el caret
 * `dropdown-toggle::after`.
 */
const SelectLikeToggle = React.forwardRef(function SelectLikeToggle(
    {children, onClick, className, ...props},
    ref,
) {
    return (
        <button
            {...props}
            ref={ref}
            type='button'
            onClick={onClick}
            className={`${
                className || ''
            } custom-select custom-select-sm text-left`.replace(
                'dropdown-toggle',
                '',
            )}
            style={{minWidth: 140}}
        >
            {children}
        </button>
    );
});

/**
 * Selección múltiple de niveles como dropdown con casillas. El menú no se
 * cierra al marcar (las casillas no son `Dropdown.Item`, que sí lo cierran);
 * se cierra con click fuera o Escape.
 */
function BandMultiSelect({id, options, value, onChange, placeholder, testId}) {
    const intl = useIntl();
    const selected = new Set(value);

    function toggle(band) {
        // Conserva el orden de `options`, no el del click.
        onChange(
            options.filter((option) =>
                option === band ? !selected.has(option) : selected.has(option),
            ),
        );
    }

    return (
        <Dropdown className='mr-2 mb-2' data-test={testId}>
            <Dropdown.Toggle
                as={SelectLikeToggle}
                id={id}
                aria-label={placeholder}
                data-test={`${testId}Toggle`}
            >
                {bandToggleLabel(intl, placeholder, selected.size)}
            </Dropdown.Toggle>
            <Dropdown.Menu className='px-3 py-2' role='group'>
                {options.map((band) => (
                    <Form.Check
                        key={band}
                        type='checkbox'
                        id={`${id}-${band}`}
                        label={labelFor(intl, 'BAND', band)}
                        checked={selected.has(band)}
                        onChange={() => toggle(band)}
                        // El menú vive dentro del Form inline, y
                        // `.form-inline .form-check` centra y encoge cada
                        // casilla; las utilidades (!important) la alinean a la
                        // izquierda a todo el ancho del menú.
                        className='w-100 justify-content-start text-nowrap py-1'
                        data-test={`${testId}Option`}
                    />
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default BandMultiSelect;
